if (!customElements.get('inventory-status')) {
  customElements.define('inventory-status', class extends HTMLElement {
    connectedCallback() {
      this.variantSelector = this.closest('.sticky-top-section')?.querySelector('.as-product-variant');
      this.notice = this.querySelector('[data-inventory-notice]');
      this.message = this.querySelector('[data-inventory-message]');

      if (!this.variantSelector || !this.notice || !this.message) return;

      this.updateInventoryStatus = this.updateInventoryStatus.bind(this);
      this.variantSelector.addEventListener('change', this.updateInventoryStatus);
      this.updateInventoryStatus();
    }

    disconnectedCallback() {
      this.variantSelector?.removeEventListener('change', this.updateInventoryStatus);
    }

    updateInventoryStatus() {
      const inventory = Number(this.variantSelector.selectedOptions[0]?.dataset.inventory);
      const threshold = Number(this.dataset.stockThreshold);
      const showNotice = Number.isFinite(inventory) && inventory > 0 && inventory <= threshold;

      this.notice.hidden = !showNotice;
      if (showNotice) {
        this.message.textContent = this.dataset.stockMessage.replace('**', inventory);
      }
    }
  });
}
